(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8803],{

/***/ 98591:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/[type]",
      function () {
        return __webpack_require__(60526);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/tailwindcss/tailwind.css
var tailwind = __webpack_require__(52490);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.a3e53517.png","height":249,"width":1048,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAS0lEQVR4nGMsnHv+/7///89NvPA+x0yCI+3Pv//XGRgYJBkYGf78Z2DgZ4ydchqogOHC0ntfYk2F2bz//GN4zcjwX+I/A+NHoEIuAITjHwJ2PhlwAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/app-store.png
/* harmony default export */ var app_store = ({"src":"/_next/static/media/app-store.e1a6b4c7.png","height":245,"width":727,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAUUlEQVR4nBWLwQmAUAxDEwQ9CKJr6UEv/l0c0EE8igN4EOx/bUj7KImXrYwKlGO9UAMl/+ze87pzdeBT9kOgg9OXFDeBMsgxUcn2R5M/MhxqK9efFfZ/yfWFAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/play-store.png
/* harmony default export */ var play_store = ({"src":"/_next/static/media/play-store.4453af1b.png","height":245,"width":728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAT0lEQVR4nBWMsQmAQBAE5+B5RENDO9LERGu1F7t4MBDB/b1guGEZLrb9nBEv8BNGBqr9s48ZTBJHwKVg8TjYm6Pi6I41P6CKonnwNfCYknQP1hcFFRwnhgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/layout.tsx










function Header() {
    const [showDownload, setShowDownload] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { utm_source , utm_medium  } = router.query;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: "border-b sticky top-0 bg-white py-3.5 px-4 z-30",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-3xl mx-auto py-1 flex flex-row items-center justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-h-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: logo,
                            width: 169,
                            height: 40,
                            objectFit: "contain",
                            quality: "100",
                            alt: "Logo",
                            priority: true
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mobile-portrait:hidden -mobile-portrait:flex flex-row items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://apps.apple.com/app/apple-store/id1603189650?pt=122829483&mt=8&ct=".concat(utm_source !== null && utm_source !== void 0 ? utm_source : "undefined", "-").concat(utm_medium !== null && utm_medium !== void 0 ? utm_medium : "undefined"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-h-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: app_store,
                                    width: 120,
                                    height: 40,
                                    quality: "100",
                                    alt: "Apple App Store",
                                    priority: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "market://details?id=com.jdjeon&referrer=".concat(encodeURIComponent("utm_srouce=".concat(utm_source !== null && utm_source !== void 0 ? utm_source : "undefined", "&utm_medium=").concat(utm_medium !== null && utm_medium !== void 0 ? utm_medium : "undefined"))),
                            className: "ml-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-h-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: play_store,
                                    width: 120,
                                    height: 40,
                                    quality: "100",
                                    alt: "Google Play Store",
                                    priority: true
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "-mobile-portrait:hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-2 border rounded cursor-pointer",
                            onClick: ()=>setShowDownload(!showDownload),
                            children: "다운로드"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "absolute mt-2 -ml-12 bg-white min-w-fit ".concat(!showDownload ? "hidden" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://apps.apple.com/app/apple-store/id1603189650?pt=122829483&mt=8&ct=".concat(utm_source !== null && utm_source !== void 0 ? utm_source : "undefined", "-").concat(utm_medium !== null && utm_medium !== void 0 ? utm_medium : "undefined"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "max-h-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: app_store,
                                                width: 120,
                                                height: 40,
                                                quality: "100",
                                                alt: "Apple App Store",
                                                priority: true
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "-mt-px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "market://details?id=com.jdjeon&referrer=".concat(encodeURIComponent("utm_srouce=".concat(utm_source !== null && utm_source !== void 0 ? utm_source : "undefined", "&utm_medium=").concat(utm_medium !== null && utm_medium !== void 0 ? utm_medium : "undefined"))),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "max-h-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: play_store,
                                                width: 120,
                                                height: 40,
                                                quality: "100",
                                                alt: "Google Play Store",
                                                priority: true
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "bg-gray-700 text-zinc-100 px-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-3xl mx-auto py-1 flex flex-row items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "shrink-0 mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: logo,
                                width: 169,
                                height: 40,
                                objectFit: "contain",
                                quality: "100",
                                alt: "Logo",
                                priority: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center justify-between flex-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-5 my-0.5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/policies/service",
                                    children: "이용약관"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-5 my-0.5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/policies/privacy",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "개인정보처리방침"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-5 my-0.5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/policies/location",
                                    children: "위치기반서비스 이용약관"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-3xl mx-auto py-4 mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "주식회사 휴비즈"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "서울특별시 성동구 아차산로17길 49, RB101호, RB102호, RB103호(성수동2가, 생각공장 데시앙플렉스)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "사업자번호: 420-86-00886"
                    })
                ]
            })
        ]
    });
}
function Modal(param) {
    let { isMobileOnly , isIOS  } = param;
    const [showModal, setShowModal] = (0,react.useState)(true);
    const router = (0,next_router.useRouter)();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { utm_source , utm_medium  } = router.query;
    if (!isMobileOnly) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    const storeLink = isIOS ? "https://apps.apple.com/app/apple-store/id1603189650?pt=122829483&mt=8&ct=".concat(utm_source !== null && utm_source !== void 0 ? utm_source : "undefined", "-").concat(utm_medium !== null && utm_medium !== void 0 ? utm_medium : "undefined") : "market://details?id=com.jdjeon&referrer=".concat(encodeURIComponent("utm_srouce=".concat(utm_source !== null && utm_source !== void 0 ? utm_source : "undefined", "&utm_medium=").concat(utm_medium !== null && utm_medium !== void 0 ? utm_medium : "undefined")));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "overflow-hidden z-40 bg-black/60 fixed inset-0".concat(!showModal ? "hidden" : ""),
        onClick: ()=>setShowModal(false),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col py-4 px-8 bg-white absolute bottom-0 left-0 right-0 z-50 rounded-t-3xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-center items-center my-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/app-icon.png",
                            alt: "App Icon",
                            className: "w-20 h-20"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "ml-4 font-black text-lg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "전대전 앱에서 더욱 편리하게"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "우리 동네 소식을 알아보세요!"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: storeLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center my-2 bg-app-blue-background text-app-blue h-12",
                        children: "앱 다운로드"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center items-center my-2 text-neutral-400",
                    children: "웹으로 보기"
                })
            ]
        })
    });
}
function Layout(param) {
    let { children , device  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col h-screen justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "전국대신전해드립니다"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "전국대신전해드립니다, 전대전 앱에서 다양한 지역 소식을 자유롭게 나눠 보세요! 페이스북 <대신 전해드립니다> 지역 페이지 제보함과 연동해 다양한 채널에서 더욱 편리하게 필요한 정보를 나눌 수 있어요."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        dangerouslySetInnerHTML: {
                            __html: "\n              html,\n              body {\n                padding: 0;\n                margin: 0;\n                font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,\n                Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n              }\n\n              a {\n                color: inherit;\n                text-decoration: none;\n              }\n\n              * {\n                box-sizing: border-box;\n              }\n            "
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "mb-auto",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                ...device
            })
        ]
    });
}


/***/ }),

/***/ 60526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14700);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26018);



const Policy = (param)=>{
    let { body  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "px-4 my-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-3xl mx-auto prose",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_2__/* .ReactMarkdown */ .D, {
                children: body
            })
        })
    });
};
Policy.getLayout = (page, options)=>{
    var ref;
    const device = (ref = options === null || options === void 0 ? void 0 : options.device) !== null && ref !== void 0 ? ref : {
        isMobileOnly: false,
        isIOS: false,
        isAndroid: false
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        device: device,
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Policy);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [31384,14700,49774,92888,40179], function() { return __webpack_exec__(98591); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);